import React from 'react';

import { ToggleButton } from "../../../../components/optionalFieds";

const CoManagerItem = ({ data, index, handleEdit, handleDelete }) => {
    return (
        <li className="mb-2 grid grid-cols-8 items-center justify-between gap-2 rounded-xl border border-slate-200 bg-[#f7f2ef] p-4">
            <p className="col-span-2 truncate text-sm font-semibold text-[#211b4f]">
                {data.firstName} {data.lastName}
            </p>
            <p className="col-span-3 text-sm text-gray-500 truncate">{data.email}</p>
            <p className="col-span-2 text-sm text-gray-500 truncate">{data.title}</p>
            <div className="col-span-1 flex justify-end">
                <button
                    type='button'
                    onClick={() => handleEdit(index)}
                    className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-[#211b4f] hover:bg-white"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                        <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                    </svg>
                </button>
                <button
                    type="button"
                    onClick={() => handleDelete(index)}
                    className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-red-600 hover:bg-red-50"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                    </svg>
                </button>
            </div>
        </li>
    );
};


const CoManagerList = ({ coManagers, handleEdit, handleDelete }) => {
    return (
        <ul className="divide-y divide-gray-200">
            {coManagers.map((coData, index) => (
                <CoManagerItem key={index} data={coData} index={index} handleEdit={handleEdit} handleDelete={handleDelete} />
            ))}
        </ul>
    );
};


const CoManagerSection = ({ data, setIsCoManagerModalOpen, handleEdit, handleDelete, handleIsCoManagerExists, isCoManagerExists }) => {
    return (
        <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
            <div className="flex items-center justify-between gap-4">
                <div>
                    <h2 className="text-base font-bold text-[#0a1445] sm:text-lg">Will there be a Co Team Lead?</h2>
                </div>
                <div>
                    <ToggleButton
                        isToggled={isCoManagerExists}
                        handleToggle={handleIsCoManagerExists}
                        name="comanagerexisttoggle"
                    />
                </div>
            </div>
            {isCoManagerExists && <div className='mt-4 flex items-center justify-between border-t border-slate-100 pt-4'>
                <div>
                    <h2 className="text-sm font-semibold text-[#0a1445]">Co Team Lead Comp Info <span className="text-red-600">*</span></h2>
                </div>
                <div>
                    <button 
                        onClick={() => setIsCoManagerModalOpen(true)}
                        className="inline-flex h-9 w-9 flex-none items-center justify-center rounded-lg bg-[#211b4f] text-white hover:bg-[#30266c]"
                        type="button"
                        aria-label="Add Co Team Lead Comp Info"
                    >
                        <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 12h14m-7 7V5" />
                        </svg>
                    </button>
                </div>
            </div>}
            <CoManagerList coManagers={data?.co_managers} handleEdit={handleEdit}  handleDelete={handleDelete} />
        </section>
    );
};

export default CoManagerSection;
